import axios from "axios";
import toast from "react-hot-toast";
import { BASE_URL } from "../../routes/apiurls";
import { getToken } from "../../utils/pip";
import { adminPaths } from "../../routes/admin";
import { coachPaths } from "../../routes/coach";
import { enterPrisesPaths } from "../../routes/enterprises";

export const API_REQUEST = async (props) => {
  const {
    url,
    method,
    data,
    headers,
    params,
    isErrorToast = true,
    isSuccessToast = true,
    currentPanel = "",
  } = props;

  const getCurrentPanel = () => {
    const list = ["coach", "admin", "freelancer", "hire-talent"];
    const path = window.location.pathname;
    const panel = path.split("/")[1];
    return list?.includes(panel) ? panel : currentPanel || "freelancer";
  };
  const token = getToken(getCurrentPanel());
  const isAbsoluteUrl = /^https?:\/\//i.test(url || "");

  const requestOptions = {
    url: isAbsoluteUrl ? url : BASE_URL + url,
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      ...headers,
    },
    params: method === "GET" ? params : undefined,
    data: method !== "GET" ? data : undefined,
  };
  try {
    const response = await axios(requestOptions);
    if (isSuccessToast && method !== "GET") {
      const isSuccess =
        response?.data?.success ?? response?.data?.status ?? false;
      const message = response?.data?.message;
      if (isSuccess) {
        toast.success(message || "Operation successful");
      } else {
        console.log(response, "responseresponseresponse")
        toast.error(message || "Something went wrong");
      }
    }
    return response?.data;
  } catch (error) {
    if (error.response) {
      if (error?.response?.status == 401) {
        const panelValue = getCurrentPanel();
        if (isErrorToast) toast.error(error?.response?.data?.message);
        if (panelValue == "admin") {
          localStorage.removeItem('admin_token_nuvio');
          localStorage.removeItem('createBootCampFormData');
          window.location.href = `${adminPaths?.Login}`;
        } else if (panelValue == "freelancer") {
          localStorage.removeItem('freelancer_token_nuvio');
          window.location.href = `${enterPrisesPaths?.Enterprise}`;
        } else if (panelValue == "hire-talent") {
          localStorage.removeItem('hire-talent_token_nuvio');
          window.location.href = `${enterPrisesPaths?.Enterprise}`;
        } else {
          localStorage.removeItem('coach_token_nuvio');
          window.location.href = `${enterPrisesPaths?.Enterprise}`;
        }
        return;
      }
      if (isErrorToast) {
        toast.error(error?.response?.data?.message || "Something went wrong");
      }
    } else if (isErrorToast) {
      if (error.request) {
        toast.error("No response received from server");
      } else {
        toast.error("Error:", error.message);
      }
    }
    throw error.response;
  };
};
